import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faClock } from '@fortawesome/free-solid-svg-icons';

export function StorageSettingsPage() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Storage Settings</h1>
        <p className="mt-0.5 text-sm text-muted-foreground">
          Global AME configuration, retention rules, and dedup settings
        </p>
      </div>

      <div className="flex flex-col items-center justify-center rounded-xl border border-border bg-card py-20 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted">
          <FontAwesomeIcon icon={faGear} className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="mt-4 text-base font-semibold text-foreground">Storage Settings</h2>
        <p className="mt-2 max-w-sm text-sm text-muted-foreground">
          Global storage settings including default quarantine period, permanent-deletion delay,
          deduplication thresholds, and retention job scheduling.
        </p>
        <div className="mt-6 flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs text-muted-foreground">
          <FontAwesomeIcon icon={faClock} className="h-3.5 w-3.5" />
          Settings management planned for a future release
        </div>
      </div>
    </div>
  );
}
